import { useState } from 'react';
import { Download, FileText, Upload, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

export function ExportImportButtons({ onExportCSV, onExportPDF, onImportCSV, onImportPDF, exporting, importing, importingPDF, testIdPrefix }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testIdPrefix}-export-import`}>
      {onExportCSV && (
        <Button
          onClick={onExportCSV}
          disabled={exporting}
          data-testid={`${testIdPrefix}-export-csv`}
          className="bg-blue-600 hover:bg-blue-700 text-white"
          size="sm"
        >
          {exporting ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Download className="w-4 h-4 mr-1.5" />}
          Export Excl
        </Button>
      )}
      {onExportPDF && (
        <Button
          onClick={onExportPDF}
          disabled={exporting}
          data-testid={`${testIdPrefix}-export-pdf`}
          className="bg-gray-700 hover:bg-gray-800 text-white"
          size="sm"
        >
          {exporting ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <FileText className="w-4 h-4 mr-1.5" />}
          Export Pdf
        </Button>
      )}
      {onImportCSV && (
        <label className="cursor-pointer">
          <Button
            asChild
            disabled={importing}
            data-testid={`${testIdPrefix}-import-csv`}
            className="bg-blue-500 hover:bg-blue-600 text-white"
            size="sm"
          >
            <span>
              {importing ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Upload className="w-4 h-4 mr-1.5" />}
              Import CSV
            </span>
          </Button>
          <input type="file" accept=".csv" className="hidden" onChange={onImportCSV} disabled={importing} />
        </label>
      )}
      {onImportPDF && (
        <label className="cursor-pointer">
          <Button
            asChild
            disabled={importingPDF}
            data-testid={`${testIdPrefix}-import-pdf`}
            className="bg-rose-500 hover:bg-rose-600 text-white"
            size="sm"
          >
            <span>
              {importingPDF ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <FileText className="w-4 h-4 mr-1.5" />}
              Import PDF
            </span>
          </Button>
          <input type="file" accept=".pdf" className="hidden" onChange={onImportPDF} disabled={importingPDF} />
        </label>
      )}
    </div>
  );
}
